import { useNavigate } from "react-router-dom";
import { Modal, ModalContent, ModalFooter } from "../../components/Modal";
import { aspetto_logo } from "../../constant/_constant";
import { useState, useEffect } from "react";

const SuccessModal = ({ isOpen = true, onClose }) => {
  const [open, setOpen] = useState(isOpen);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    } else {
      navigate("/"); // default redirect
    }
  };

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <Modal isOpen={open}>
      <ModalContent>
        <div className="text-center w-50 mb-3 m-auto">
          <img src={aspetto_logo} height={80} alt="aspetto_logo" />
        </div>
        <p className="text-center text-success">
          Thank you for your valuable feedback!
        </p>
        <p className="text-center">
          We truly appreciate your time and effort in helping us improve. Your
          insights will play a key role in enhancing our services.
        </p>
        <p className="text-center">
          If you have any additional thoughts or suggestions, feel free to reach
          out to us at{" "}
          <a href="mailto:platform_admin@aspettoinc.com">
            platform_admin@aspettoinc.com
          </a>
          .
        </p>
      </ModalContent>
    </Modal>
  );
};

export default SuccessModal;
